import { render } from "./dashboard-index.vue?vue&type=template&id=1d86f491"
import script from "./dashboard-index.vue?vue&type=script&lang=js"
export * from "./dashboard-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__